/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

export default setCacheHas;



//////////////////
// WEBPACK FOOTER
// ../~/lodash-es/_setCacheHas.js
// module id = 1595
// module chunks = 1